module.exports = __webpack_public_path__ + "img/19.fc3c30dc.jpg";